module.exports = __webpack_public_path__ + "img/collection-weddingRingsHearts.75e9c8f.jpg";